export const COOKIE_CONSENT_OPTION = {
  ESSENTIAL: 'ESS',
  ALL: 'ALL',
};
